import React, { useContext, useEffect, useState } from 'react';
import Slider from 'react-slick';
import Context from '../../container';
import usePlatform from '../../hooks/usePlatform';
import { CursorPagination } from '../../components/Common/cursor-pagination';
import './footer.scss';
import { getAdvantage } from '../../services';
import { isValid } from '../../scripts/utils';

interface FooterItem {
  id: number;
  title: string;
  desc: string;
  logo: string;
}

const CarouselFooter = () => {
  const [index, setIndex] = useState(0);
  const context = useContext(Context);
  const { currentSite = {} } = context;
  const [list, setList] = useState<FooterItem[]>([]);
  const { isPc } = usePlatform() || {};

  useEffect(() => {
    const init = async () => {
      const data = (await getAdvantage({ id: currentSite.id })) as unknown as FooterItem[];
      setList(data);
    };
    if (isValid(currentSite.id)) {
      init();
    }
  }, [currentSite.id]);

  const settings = {
    infinite: true,
    swipe: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    cssEase: 'linear',
    rows: 1,
    arrows: false,
    beforeChange: (current: number, next: number) => {
      setIndex(next);
    },
    centerPadding: '0px'
  };

  const Container = isPc ? React.Fragment : Slider
  return (
    <div className={isPc ? "banner-footer" : undefined}>
      <div className="filter-blur hidden-in-mobile"></div>
      <Container {...(isPc ? {} : settings)}>
        {list.map((d, i) => {
          const { id, logo, title, desc } = d;
          return (
            <div key={id} className="banner-footer-item">
              <img width={24} src={logo} alt="" />
              <div className="content">
                <div className="title">{title}</div>
                <div className="desc">{desc}</div>
              </div>
            </div>
          );
        })}
      </Container>
      {!isPc && <div className="banner-footer-page">
        <CursorPagination
          count={list.length}
          activeIndex={index}
        />
      </div>}
    </div>
  );
};
export default CarouselFooter;
